export const spring = { type: "spring", stiffness: 400, damping: 10 };